<template>
    <modal @close="closeFromModal">
        <h5 slot="header">
            {{ promoCodeId === null ? $tl("labels.form.actions.add") : $tl("labels.form.actions.edit") }}
            {{ $tl("labels.clickAndCollect.modals.titles.giftVoucher") }}
        </h5>
        <div slot="body">
            <add-click-and-collect-promo-code ref="addClickAndCollectPromoCode" :promoCodeId="promoCodeId" @saved="$emit('saved')" />
        </div>
        <div slot="footer" class="d-flex">
            <button type="button" class="modal-default-button btn btn-sm btn-secondary btn-circle" @click="close">
                {{ $tl("labels.form.actions.cancel") }}
            </button>
            <button type="button" class="btn btn-sm btn-success btn-circle ms-2" @click="$refs.addClickAndCollectPromoCode.save()">
                {{ $tl("labels.form.actions.save") }}
            </button>
        </div>
    </modal>
</template>

<script>
import addClickAndCollectPromoCode from "../../../clickAndCollect/settings/addClickAndCollectPromoCode";

export default {
    props: {
        promoCodeId: {
            default: null,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            e.stopPropagation();
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        addClickAndCollectPromoCode,
    },
};
</script>
